import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import { VERSIONS_ENPOINT } from './constants';

export function useVersionsService() {
  const [version, setVersion] = React.useState();
  const [loading, setLoading] = React.useState();
  const [error, setError] = React.useState();

  const { backendGet } = Sebrae.useBackend();

  React.useEffect(() => {
    setVersion([]);
    setError(false);
    setLoading(true);

    backendGet(VERSIONS_ENPOINT)
      .then(setVersion)
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [backendGet]);
  return [version, loading, error];
}
